const clampNormalized = (value) => Math.max(0, Math.min(1, value));

// 扫描器给出采样 canvas 的像素坐标；追踪和合规计算统一使用 0~1 坐标。
export const normalizeDetectorCorners = (corners, frameWidth, frameHeight) => {
  if (corners?.length !== 4 || !frameWidth || !frameHeight) return [];

  return corners.map((corner) => ({
    x: clampNormalized(corner.x / frameWidth),
    y: clampNormalized(corner.y / frameHeight),
  }));
};

export const denormalizeCorners = (corners, frameWidth, frameHeight) =>
  corners.map((corner) => ({
    x: corner.x * frameWidth,
    y: corner.y * frameHeight,
  }));

// 归一化坐标仍属于未裁切的视频空间。SVG viewBox 的宽度使用源视频宽高比，
// 所以 x 乘宽高比后，在 object-fit: contain / cover 下都能保持原始几何比例。
export const toOverlayCorners = (corners, frameAspectRatio = 4 / 3) =>
  (corners || []).map((corner) => ({
    x: corner.x * frameAspectRatio,
    y: corner.y,
  }));

export const getOverlayPreserveAspectRatio = (objectFit = "contain") =>
  objectFit === "cover" ? "xMidYMid slice" : "xMidYMid meet";
